import {Router} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import {ApiService} from 'src/app/services/api.service';
import {Component, OnInit} from '@angular/core';
import * as moment from 'moment';
import * as $ from 'jquery';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import {FormGroup, FormControl, Validators, FormBuilder} from '@angular/forms';
import {IResponseApi} from 'src/app/interfaces/IResponseApi';
import {ETypeDocument} from 'src/app/enums/ETypeDocument';
import {NzModalService} from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-conciliation',
    templateUrl: './conciliation.component.html',
    styleUrls: ['./conciliation.component.scss']
})
export class ConciliationComponent implements OnInit {

    lang: any = this.translate.getDefaultLang();

    public allCustomersData: any = this.allCustomers(this.cookie.get('merchant'));
    public allCustomersDataTmp: any = this.allCustomers(this.cookie.get('merchant'));
    public titlePage = 'Clientes';
    public filters: any = this.getFilters();
    public formFilters: FormGroup;

    isDetailExportVisible = false;
    isNewCustomerModalOpen = false;
    formCustomer: FormGroup;
    isInstruccionesVisible = false;
    creationResponse = 'test';
    showCompletedFieldErrorMessage = false;


    from_date: any = moment('2019').startOf('month').add(1, 'days').format('YYYY-MM-DD');
    from_date_cashout: any = moment().startOf('month').add(1, 'days').format('YYYY-MM-DD');
    to_date: any = moment().add(1, 'days').format('YYYY-MM-DD');
    to_date_cashout: any = moment().add(1, 'days').format('YYYY-MM-DD');

    public userDetails = JSON.parse(this.cookie.get('ud')).userDetails;
    public MerchantActive = JSON.parse(this.cookie.get('ud')).MerchantActive;
    public merchant: any = JSON.parse(this.cookie.get('ud')).MerchantActive[0].MerchantData.MerchantCode;

    date = {
        start: new Date(),
        end: new Date()
    }

    constructor(
        private api: ApiService,
        private cookie: CookieService,
        private router: Router,
        private fb: FormBuilder,
        public translate: TranslateService,
        private modalService: NzModalService) {
        this.formCustomer = this.createFormGroup();
    }

    ngOnInit() {
        this.changeMerchant();
        this.api.validateMerchantPermissions();
        this.createFormFilters();
    }

    // crea formulario para creación de cliente
    createFormGroup() {
        return new FormGroup({
            FirstName: new FormControl('', [Validators.required]),
            LastName: new FormControl('', [Validators.required]),
            TypeDoc: new FormControl('', [Validators.required]),
            DocNumber: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(3)]),
            Email: new FormControl(''),
            Mobile: new FormControl('', [Validators.pattern('^[0-9]*$')]),
            Address: new FormControl(''),
            CustomerType: new FormControl('', [Validators.required]),
            CountryCode: new FormControl('', [Validators.required]),
        });
    }

    createFormFilters() {
        this.formFilters = this.fb.group({
            type_doc: [null],
            number_doc: [''],
            date_range: [[]]
        });
    }


// Ejecuta cambios en la vista cuando se cambia de merchant.
    changeMerchant() {
        this.api.merchant$.subscribe(m => {
            if (m.event === 'change-merchant') {
                this.allCustomersData = this.allCustomers(m.data);
                this.allCustomersDataTmp = this.allCustomers(m.data);
                this.merchant = m.data;
                this.api.validateMerchantPermissions();
            }
        });
    }

// Ejecuta el servicio para sonculta de todos los clientes
    async allCustomers(merchant, dataInfo: any = false) {
        if (!this.to_date) {
            this.to_date = moment().add(1, 'days').format('YYYY-MM-DD');
        }
        let from_date = moment('2000').startOf('month').format('YYYY-MM-DD');
        let to_date = moment(this.to_date).format("YYYY-MM-DD");

        if (dataInfo != false) {
            from_date = dataInfo.from;
            to_date = dataInfo.to;
        }


        const data = {
            token: JSON.parse(this.cookie.get('ud')).token,
            service: 'invoce/date',
            data: {
                from_date,
                to_date
            },
            page: 1,
            params: {
                type_doc: dataInfo.type_doc ? dataInfo.type_doc : '',
                number_doc: dataInfo.number_doc ? dataInfo.number_doc : '',
                merchantid: merchant
            }
        };

        const headers = [
            {
                name: 'Tipo de Documento',
                key: 'invoce_type',
                opc: true
            },
            {
                name: 'Número de documento',
                key: 'invoce_consecutive',
                opc: true
            },
            {
                name: 'Datos del cliente',
                key: 'customer_name',
                opc: true
            },
            {
                name: 'IVA',
                key: 'invoce_tax',
                opc: true
            },
            {
                name: 'Monto Total',
                key: 'invoce_total',
                opc: true
            },
            {
                name: 'Status',
                key: 'invoce_status',
                opc: true
            },
            {
                name: 'Forma de Pago',
                key: 'invoce_type_payment',
                opc: true
            },
            {
                name: 'Fecha de emision',
                key: 'invoce_doc_date',
                opc: true
            },
            {
                name: 'Acciones',
                key: 'opcs',
                opc: true,
                actions: [
                    {
                        name: 'Reutilizar',
                        key: 'makeInvoice',
                    },
                    {
                        name: 'Crear nota Crédito',
                        key: 'makeNoteCredit',
                    },
                    {
                        name: 'Crear nota Débito',
                        key: 'makeNoteDebit',
                    },
                    {
                        name: 'Descargar documento',
                        key: 'download',
                    }
                ]
            }

        ];

        const responseInvoices: IResponseApi = await this.api.api(data).toPromise();
        $('#charging').addClass('hide');
        return {
            headers,
            data: responseInvoices.data ? responseInvoices.data.rows : [],
            source: 'listAllInvoice'
        };
    }

// creo que no esta funcionando aún.
// Se ejecut cad vez que cambia la tabla que oista los clientes
    changeDataTable(data) {
        if (data.type && data.type === 'search') {

            if (data.data === "") {
                this.allCustomersData = this.allCustomersDataTmp;
                this.allCustomersDataTmp = this.allCustomersData;
            } else {
                this.allCustomersData = [];
                this.search(this.allCustomersDataTmp, data.data);
            }
        } else {
            this.allCustomersData = this.allCustomers(this.cookie.get('merchant'), data);
            this.allCustomersDataTmp = this.allCustomers(this.cookie.get('merchant'), data);
        }
    }

// Metodo para hacer una busqueda en listado de clietnes-
    search(array, word) {

        word = word.toLowerCase();

        var res = [];
        var headers = [];

        if (array.headers) {

            headers = array.headers;
            var index = 0;
            var itemsProcessed = 0;
            array.data.forEach(element => {

                for (var k in element) {
                    if (element.hasOwnProperty(k)) {
                        if (element[k].toString().toLowerCase().indexOf(word) > -1) {
                            res.push(array.data[index]);
                        } else {
                            if (element[k] && typeof (element[k]) == 'object') {
                                for (var x in element[k]) {
                                    for (var i in element[k][x]) {
                                        if (element[k][x][i] && element[k][x][i].toString().toLowerCase().indexOf(word) > -1) {
                                            res.push(array.data[index]);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                itemsProcessed++
                if (itemsProcessed == array.data.length) {
                    this.allCustomersData = {
                        data: res,
                        headers: headers,
                        source: 'listAllCustomer'
                    };
                }

                index++;
            });

        } else {

            array.then((e: any) => {

                headers = e.headers;
                var index = 0;
                var itemsProcessed = 0;
                e.data.forEach(element => {
                    for (var k in element) {
                        if (element.hasOwnProperty(k)) {


                            if (element[k] && element[k].toString().toLowerCase().indexOf(word) > -1) {
                                res.push(e.data[index]);
                            } else {
                                if (element[k] && typeof (element[k]) == 'object') {
                                    for (var x in element[k]) {
                                        for (var i in element[k][x]) {
                                            if (element[k][x][i] && element[k][x][i].toString().toLowerCase().indexOf(word) > -1) {
                                                res.push(e.data[index]);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    itemsProcessed++
                    if (itemsProcessed == e.data.length) {
                        this.allCustomersData = {
                            data: res,
                            headers: headers,
                            source: 'listAllCustomer'
                        };
                    }

                    index++;
                });
            });
        }

    }

    public export(): void {
        let from = moment('2000').startOf('month').format('YYYY-MM-DD');
        let to = moment().add(1, 'days').format('YYYY-MM-DD');
        if (this.formFilters.get('date_range').value.length) {
            from = moment(this.formFilters.get('date_range').value[0]).format('YYYY-MM-DD');
            to = moment(this.formFilters.get('date_range').value[1]).format('YYYY-MM-DD');
        }
        const data = {
            token: JSON.parse(this.cookie.get('ud')).token,
            merchant: this.merchant,
            service: 'export/invoice',
            data: {
                from_date: from,
                to_date: to
            }
        };


        this.api.api(data);
        $('#charging').addClass('hide');
    }

// Muesta submenu de opciones para exportar
    toggleDetailExport() {
        this.isDetailExportVisible = !this.isDetailExportVisible;
    }

// No esta funcionando
// Muestra ventana modal del formulario para crear un cliente.
    openCreateCustomer() {
        this.isNewCustomerModalOpen = !this.isNewCustomerModalOpen;
    }

// Refresca los valores de los clientes.
    refreshValues() {
        this.allCustomersData = this.allCustomers(this.cookie.get('merchant'));
        this.allCustomersDataTmp = this.allCustomers(this.cookie.get('merchant'));
    }

//Retorna los tipos de filtros usados para esta vista
    async getFilters() {

        return [
            {
                'name': 'Periodo',
                'key': ['from_date', 'to_date'],
                'type': 'period'
            },
            {
                'name': 'Tipo Cliente',
                'key': 'status',
                'type': 'select',
                'data': this.api.getCustomerType()
            }

        ];

    }


// Se ejecuta al precionar boton de cancelar.
    handleCancel() {
        this.isInstruccionesVisible = false;
        this.formCustomer = this.createFormGroup();
        this.isNewCustomerModalOpen = !this.isNewCustomerModalOpen;
        this.showCompletedFieldErrorMessage = false;
        this.refreshValues();
    }

// Manejo de errores del formulario
    handleErrors() {

        if (this.formCustomer.controls.FirstName.status === 'INVALID') {
            this.formCustomer.controls.FirstName.markAsDirty();
            this.formCustomer.controls.FirstName.markAllAsTouched();
        }

        if (this.formCustomer.controls.LastName.status === 'INVALID') {
            this.formCustomer.controls.LastName.markAsDirty();
            this.formCustomer.controls.LastName.markAllAsTouched();
        }

        if (this.formCustomer.controls.TypeDoc.status === 'INVALID') {
            this.formCustomer.controls.TypeDoc.markAsDirty();
            this.formCustomer.controls.TypeDoc.markAllAsTouched();
        }

        if (this.formCustomer.controls.DocNumber.status === 'INVALID') {
            this.formCustomer.controls.DocNumber.markAsDirty();
            this.formCustomer.controls.DocNumber.markAllAsTouched();
        }

        if (this.formCustomer.controls.Email.status === 'INVALID') {
            this.formCustomer.controls.Email.markAsDirty();
            this.formCustomer.controls.Email.markAllAsTouched();
        }

        if (this.formCustomer.controls.Mobile.status === 'INVALID') {
            this.formCustomer.controls.Mobile.markAsDirty();
            this.formCustomer.controls.Mobile.markAllAsTouched();
        }

        if (this.formCustomer.controls.Address.status === 'INVALID') {
            this.formCustomer.controls.Address.markAsDirty();
            this.formCustomer.controls.Address.markAllAsTouched();
        }

        if (this.formCustomer.controls.CustomerType.status === 'INVALID') {
            this.formCustomer.controls.CustomerType.markAsDirty();
            this.formCustomer.controls.CustomerType.markAllAsTouched();
        }

        if (this.formCustomer.controls.CountryCode.status === 'INVALID') {
            this.formCustomer.controls.CountryCode.markAsDirty();
            this.formCustomer.controls.CountryCode.markAllAsTouched();
        }
    }


// manejo del formulario en OK
    handleOk() {

        console.log("Entro al handleOk");
        if (this.formCustomer.status === 'INVALID') {
            console.log("Entro invalid formulario");
            this.showCompletedFieldErrorMessage = true;
            this.handleErrors();
        } else {
            this.showCompletedFieldErrorMessage = false;
            console.log("Paso la validacion de formulario ok");
            const data = {
                token: JSON.parse(this.cookie.get('ud')).token,
                merchant: this.merchant,
                service: 'customer/create/',
                type: 'post',
                data: {
                    MerchantCode: this.merchant,
                    FirstName: this.FirstName.value,
                    LastName: this.LastName.value,
                    TypeDoc: this.TypeDoc.value,
                    DocNumber: this.DocNumber.value,
                    Email: this.Email.value,
                    Mobile: this.Mobile.value,
                    Address: this.Address.value,
                    CustomerType: this.CustomerType.value,
                    CountryCode: this.CountryCode.value,
                    Metadata: JSON.stringify(JSON.parse(this.cookie.get('ud')).userDetails),
                }
            };

            if (!this.isInstruccionesVisible) {
                console.log("Entro a ejecutar el servicio de crear");

                this.api.api(data).toPromise().then((res: any) => {
                    this.isInstruccionesVisible = true;
                    this.creationResponse = res.UrlRedirect;
                    this.formCustomer.reset();
                    $('#charging').addClass('hide');
                    this.refreshValues();
                })
                    .catch(e => {
                        console.log(e);
                        $('#charging').addClass('hide');
                        if (e.status === 401 || e.status === 0) {
                            this.cookie.set('ud', '');
                            this.router.navigate(['/']);
                        }
                    });

            } else {
                this.handleCancel();
                this.refreshValues();
                this.creationResponse = '';
            }
        }
    }


    get FirstName() {
        return this.formCustomer.get('FirstName');
    }

    get LastName() {
        return this.formCustomer.get('LastName');
    }

    get TypeDoc() {
        return this.formCustomer.get('TypeDoc');
    }

    get DocNumber() {
        return this.formCustomer.get('DocNumber');
    }

    get Email() {
        return this.formCustomer.get('Email');
    }

    get Mobile() {
        return this.formCustomer.get('Mobile');
    }

    get Address() {
        return this.formCustomer.get('Address');
    }

    get CustomerType() {
        return this.formCustomer.get('CustomerType');
    }

    get CountryCode() {
        return this.formCustomer.get('CountryCode');
    }

    public gotoAction(event): void {
        if (event.action === 'makeInvoice') {
            if (ETypeDocument.invoice !== event.type) {
                this.modalService.info({
                    nzTitle: 'Información',
                    nzContent: '<p>Solo se pueden <b>reutilizar</b> las facturas</p>',
                    nzOnOk: () => console.log('Info OK')
                });
                return;
            }
            this.router.navigate(['/conciliation/create-voucher/factura/toReuse/FAC/' + event.invoice]);
        }
        if (event.action === 'makeNoteCredit') {
            if (ETypeDocument.invoice !== event.type) {
                this.modalService.info({
                    nzTitle: 'Información',
                    nzContent: '<p>Solo se pueden hacer <b>notas de crédito</b> a las facturas</p>',
                    nzOnOk: () => console.log('Info OK')
                });
                return;
            }
            this.router.navigate(['/conciliation/create-voucher/factura/toReuse/NCR/' + event.invoice]);

        }
        if (event.action === 'makeNoteDebit') {
            if (ETypeDocument.invoice !== event.type) {
                this.modalService.info({
                    nzTitle: 'Información',
                    nzContent: '<p>Solo se pueden hacer <b>notas de debito</b> a las facturas</p>',
                    nzOnOk: () => console.log('Info OK')
                });
                return;
            }
            this.router.navigate(['/conciliation/create-voucher/factura/toReuse/NDB/' + event.invoice]);
        }
        if (event.action === 'download') {
            console.log(event.data.invoce_url_document);
            // window.location.href = event.url;
        }

        if (event.data.consecutive) {
            this.router.navigate(['/conciliation/create-voucher/factura/toReuse/' + event.data.typeDocu + '/' + event.data.consecutive]);
        }
    }

    getDataWithFilters() {
        const data: any = {};
        if (this.formFilters.get('date_range').value.length) {
            data.from = moment(this.formFilters.get('date_range').value[0]).format('YYYY-MM-DD');
            data.to = moment(this.formFilters.get('date_range').value[1]).format('YYYY-MM-DD');
        } else {
            data.from = moment('2000').startOf('month').format('YYYY-MM-DD');
            data.to = moment().add(1, 'days').format('YYYY-MM-DD');
        }
        data.type_doc = this.formFilters.get('type_doc').value ? this.formFilters.get('type_doc').value : '';
        data.number_doc = this.formFilters.get('number_doc').value;

        this.allCustomersData = this.allCustomers(this.merchant, data);

    }

}
